import { CSSProperties } from 'react';
import {
  DateTimePicker as MUIDateTimePicker,
  DateTimePickerProps as MUIDateTimePickerProps,
} from '@mui/x-date-pickers/DateTimePicker';
import { PickersActionBarAction } from '@mui/x-date-pickers/PickersActionBar';

import colors from '@atom/styles/colors';

import { DateTimePickerActionBar } from './DateTimePickerActionBar';
import PickerTextField from './PickerTextField';

const styles = {
  pickerIcon: {
    color: colors.neutral.gray,
  },
};

type CustomProps = {
  // Hides the clear button in the date time picker menu
  hideClear?: boolean;
};

type AtomMUIProps = {
  value: Date;
  onChange: (date: Date) => void;
  onClick?: () => void;
  onBlur?: () => void;
  style?: CSSProperties;
  autoFocus?: boolean;
  disabled?: boolean;
  label?: string;
  error?: boolean;
  helperText?: string;
  inputSx?: any;
  inputLabelSx?: any;
  shouldDisableDate?: (date: Date) => boolean;
  'data-cy'?: string;
};

export type DateTimePickerPropsNew = CustomProps & AtomMUIProps;

export const DateTimePicker = (props: DateTimePickerPropsNew) => {
  const {
    error,
    helperText,
    inputSx,
    inputLabelSx,
    style,
    onClick,
    onBlur,
    hideClear,
    'data-cy': dataCy,
    ...data
  } = props;
  const MUIProps: MUIDateTimePickerProps = data;

  const actions: PickersActionBarAction[] = hideClear
    ? ['today', 'accept', 'cancel']
    : ['today', 'accept', 'cancel', 'clear'];

  return (
    <div style={{ width: '100%', ...style }}>
      <MUIDateTimePicker
        {...MUIProps}
        fullWidth
        slots={{
          textField: PickerTextField,
          actionBar: DateTimePickerActionBar,
        }}
        slotProps={{
          actionBar: {
            actions,
            sx: { '& > button:first-of-type': { marginRight: 'auto' } },
          },
          textField: {
            fullWidth: true,
            error,
            helperText,
            onClick,
            onBlur,
            slotProps: {
              input: inputSx,
              inputLabel: inputLabelSx,
            },
            'data-cy': dataCy,
          } as any,
          openPickerIcon: {
            style: styles.pickerIcon,
          },
        }}
      />
    </div>
  );
};
